import type { TPaulOpenEventDetail } from "./paulQuickActions";

export const LEDGER_PAUL_OPEN_EVENT = "ledger-paul:open";

export const openLedgerPaulPanel = (detail?: TPaulOpenEventDetail) => {
	if (typeof window === "undefined") return;
	window.dispatchEvent(new CustomEvent(LEDGER_PAUL_OPEN_EVENT, { detail }));
};

const LEDGER_PAUL_TURN_COMPLETE =
	"ledger-paul:turn-complete";

export const notifyLedgerPaulTurnComplete = (
	datasetId: string
) => {
	window.dispatchEvent(
		new CustomEvent(LEDGER_PAUL_TURN_COMPLETE, {
			detail: { datasetId },
		})
	);
};

export const subscribeToLedgerPaulTurnComplete = (
	datasetId: string,
	onTurnComplete: () => void
) => {
	const listener = (event: Event) => {
		if (
			(event as CustomEvent<{ datasetId: string }>).detail
				.datasetId === datasetId
		) {
			onTurnComplete();
		}
	};
	window.addEventListener(
		LEDGER_PAUL_TURN_COMPLETE,
		listener
	);
	return () => {
		window.removeEventListener(
			LEDGER_PAUL_TURN_COMPLETE,
			listener
		);
	};
};
